import React, { useContext, useEffect, useRef, useState } from "react";
import Header3 from "../components/Header3";
import "../styles/homestyle.css";


import { Button, Card, Carousel, Container, Modal } from "react-bootstrap";
import Footer2 from "../components/Footer2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import leftArrow from "./image/moveimgarrow.png"; // Left arrow
import rightArrow from "./image/moveimgarrow.png"; // Right arrow (same image, rotated)
import { BASE_URL } from "../config/BaseUrls";
import { APP_STORE_URL, PLAY_STORE_URL } from "../constants/storeUrls";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "../AxiosInstance";
import { useAuth } from "../context/auth";
import {
  GoogleLogin,
  GoogleOAuthProvider,
  // useGoogleLogin,
} from "@react-oauth/google";
import { ChatState } from "../context/ChatProvider";
import { LanguageContext } from "../context/LanguageContext";
import {  resolveBookImageUrl } from "../utils/urlHelpers";
import { trackEvent } from "../utils/googleAnalytics";
import {
  Users,
  Coffee,
  BookOpen,
  CalendarDays,
  MapPin,
  Video,
  ChevronRight,
  EyeOff,
  Eye,
  X,
} from "lucide-react";

const genders = [
  "Male",
  "Female",
  "Other",

  // Add other countries as needed
];

// Lanuguage Change All Home
const homeRead = {
  english: {
    ReadText: `Read books, meet people, make connections.

`,
  },
  italiano: {
    ReadText: `Leggi, incontra nuove persone
 e crea connessioni.
`,
  },
  deutsch: {
    ReadText: `Lies Bücher, triff Menschen und knüpfe Verbindungen.
`,
  },
  español: {
    ReadText: `Lee libros, conoce gente y haz conexiones
`,
  },
  francais: {
    ReadText: `Lis des livres, rencontre des gens et fais des connexions
`,
  },
  nihongo: {
    ReadText: `本を読んで、人と出会い、つながりを作る。`,
  },
  nederlands: {
    ReadText: `Lees boeken, ontmoet mensen, maak verbindingen.`,
  },
  chinese: {
    ReadText: `阅读书籍，结识朋友，建立联系。`,
  },
};
const homeHero = {
  english: {
    HeroText: `Whether you are an avid reader or just someone looking for genuine connections, fuel your social life joining an Ofellio Book Club, Book Duo and Silent Reading.`,
  },
  italiano: {
    HeroText: `Sia che tu sia un appassionato lettore o in cerca di connessioni sincere, arricchisci la tua vita sociale con Ofellio Book Club, Book Duo e Silent Reading
`,
  },
  deutsch: {
    HeroText: `Egal, ob du ein leidenschaftlicher Leser bist oder nach echten Verbindungen suchst, bereichere dein Sozialleben mit Ofellio Book Club, Book Duo und Silent Reading.
`,
  },
  español: {
    HeroText: `Ya seas un lector apasionado o alguien en busca de conexiones genuinas, enriquece tu vida social uniéndote a Ofellio Book Club, Book Duo y Silent Reading.`,
  },
  francais: {
    HeroText: `Que vous soyez un lecteur passionné ou en quête de connexions authentiques, enrichissez votre vie sociale en rejoignant Ofellio Book Club, Book Duo et Silent Reading.`,
  },
  nihongo: {
    HeroText: `読書好きな方も、真のつながりを求める方も、Ofellio Book Club、Book Duo、Silent Readingで社会生活を豊かにしよう`,
  },
  nederlands: {
    HeroText: `Of je nu een fervente lezer bent of gewoon op zoek bent naar echte verbindingen, verrijk je sociale leven door je aan te sluiten bij een Ofellio Boekenclub, Book Duo en Stille Leessessie.`,
  },
  chinese: {
    HeroText: `无论您是狂热的读者，还是只是寻找真诚联系的人，加入Ofellio图书俱乐部、图书双人组和静读会，丰富您的社交生活。`,
  },
};

const homeLook = {
  english: {
    ReadText: `Look for events in your area or on-line events.`,
    Citytext: `City`,
    // EventText: `Event Near`,
    EventText: `Latest book events`,

    SeeAllEventText: `See all events `,
    SeeAllBookEventsText: `See all book events`,
    SoonAvailableText: `Download the app`,
    BookDuoTitle: `Book Duo`,
    BookClubTitle: `Book Club`,
    BookSilentTitle: `Silent Reading`,
    BookDuoFirstText: `Are you looking for a personal connection? A Book Duo is perfect for you!`,
    BookDuoSecondText: `Simply pick a book of your choice, select the gender and age range of the partner you would like to connect with, and you are all set! Once someone will show interest, you will start a chat and arrange the details of your one-to-one event.`,

    BookClubFirstText: `Discover book clubs in-person in your area or on-line, hosted in a snug setting such as cafes, bars or a welcoming venue or via video conference.`,
    BookClubSecondText: ` Each Ofellio Book Club welcomes up to 8 participants, sorted by age to offer a more comfortable and engaging experience. The discussion will be facilitated by an Ofellio’s Ambassador, ensuring a lively and inclusive atmosphere.`,

    BookSilentFirstText: `Held in a relaxing andcomfortable setting, SilentReadings offer a peaceful escapefor up to 10 readers.`,
    BookSilentSecondText: `Led by an Ofellio’s Ambassador,each session invites you to bringyour own book, read quietly, andoptionally connecting withothers in a relaxed atmosphere`,

    DuoBtnText: `Create Book Duo`,
    ClubBtnText: `Create Book Club`,
    SilentBtnText: `Create Silent Reading`,

    JoinText: `Ofellio is a free platform designed for anyone looking to connect with others and share thoughts and feelings inspired by a book. Your gateway to community, friendship, and real connections.`,
  },
  italiano: {
    ReadText: `Cerca eventi nella tua zona o eventi online.`,
    Citytext: `Città o CAP`,
    // EventText: `Eventi a`,
    EventText: `Ultimi eventi letterari`,

    SeeAllEventText: `Tutti gli eventi `,
    SeeAllBookEventsText: `Vedi tutti gli eventi letterari`,
    SoonAvailableText: `Scarica l'app`,
    BookDuoTitle: `Book Duo`,
    BookClubTitle: `Book Club`,
    BookSilentTitle: `Silent Reading`,
    BookDuoFirstText: `Cerchi una connessione autentica? Un Book Duo è perfetto per te!`,
    BookDuoSecondText: `Scegli semplicemente un libro, seleziona il genere e la fascia d’età del partner con cui vuoi entrare in contatto, e sei pronto! Quando qualcuno mostrerà interesse, inizierai una chat e organizzerai i dettagli del tuo evento one-to-one`,

    BookClubFirstText: `Scopri i Book Club di persona nella tua zona o online, organizzati in ambienti accoglienti come caffè, bar o luoghi ospitali  , oppure tramite videoconferenza. `,
    BookClubSecondText: `Ogni Ofellio Book Club accoglie fino a 8 partecipanti, suddivisi per fascia d'età per offrire un'esperienza più confortevole e coinvolgente. La discussione sarà facilitata da un Ambassador Ofellio, garantendo un'atmosfera vivace e inclusiva`,

    BookSilentFirstText: `Tenuti in un ambiente rilassante e confortevole, i Silent Readings offrono una tranquilla fuga per un massimo di 10 lettori.`,
    BookSilentSecondText: `Guidata da un Ambassador Ofellio, ogni sessione ti invita a portare il tuo libro, leggere in silenzio e, se lo desideri, entrare in contatto con gli altri in un’atmosfera distesa.`,

    DuoBtnText: `Crea Book Duo`,
    ClubBtnText: `Crea Book Club`,
    SilentBtnText: `Crea Silent Reading`,

    JoinText: `Ofellio è una piattaforma gratuita pensata per chi desidera connettersi con gli altri e condividere pensieri ed emozioni ispirati da un libro. Il tuo punto di accesso alla comunità, all'amicizia e a connessioni autentiche.`,
  },
  deutsch: {
    ReadText: `Suche nach Veranstaltungen in deiner Nähe oder online`,
    Citytext: `Stadt oder PLZ`,
    // EventText: `Veranstaltungen in`,
    EventText: `Neueste Buchveranstaltungen`,

    SeeAllEventText: `Alle anzeigen`,
    SeeAllBookEventsText: `Alle Buchveranstaltungen ansehen`,
    SoonAvailableText: `App herunterladen`,
    BookDuoTitle: `Book Duo`,
    BookClubTitle: `Book Club`,
    BookSilentTitle: `Silent Reading`,
    BookDuoFirstText: `Bist du auf der Suche nach einer authentischen Verbindung? Ein Book Duo ist perfekt für dich!`,
    BookDuoSecondText: ` Wähle einfach ein Buch, wähle das Genre und das Altersbereich des Partners, mit dem du dich verbinden möchtest, und schon bist du bereit! Wenn jemand Interesse zeigt, startest du einen Chat und organisierst die Details deines One-to-One-Events`,

    BookClubFirstText: `Entdecke Buchclubs vor Ort in deiner Nähe oder online, veranstaltet in gemütlichen Umgebungen wie Cafés, Bars oder einladenden Veranstaltungsorten oder per Videokonferenz.`,
    BookClubSecondText: `Jeder Ofellio Book Club heißt bis zu 8 Teilnehmer willkommen, nach Altersgruppen sortiert, um eine angenehmere und ansprechendere Erfahrung zu bieten. Die Diskussion wird von einem Ofellio-Ambassador moderiert, der eine lebendige und inklusive Atmosphäre gewährleistet`,

    BookSilentFirstText: `In einer entspannten und komfortablen Umgebung bieten Silent Readings bis zu 10 Leserinnen und Lesern eine ruhige Auszeit.`,
    BookSilentSecondText: `Geleitet von einem Ofellio-Ambassador lädt jede Sitzung dazu ein, dein eigenes Buch mitzubringen, in Stille zu lesen und, wenn du möchtest, dich in einer lockeren Atmosphäre mit anderen auszutauschen.`,

    DuoBtnText: `Erstelle Book Duo`,
    ClubBtnText: `Erstelle Book Club`,
    SilentBtnText: `Erstelle Silent Reading`,

    JoinText: `Ofellio ist eine kostenlose Plattform für alle, die sich mit anderen verbinden und Gedanken sowie Gefühle teilen möchten, die durch ein Buch inspiriert wurden. Dein Tor zu Gemeinschaft, Freundschaft und echten Verbindungen`,
  },
  español: {
    ReadText: `Busca eventos en tu área o  en línea.`,
    Citytext: `Ciudad o cód. Postal`,
    // EventText: `Eventos en`,
    EventText: `Últimos eventos de libros`,

    SeeAllEventText: `Ver todos`,
    SeeAllBookEventsText: `Ver todos los eventos de libros`,
    SoonAvailableText: `Descarga la app`,
    BookDuoTitle: `Book Duo`,
    BookClubTitle: `Book Club`,
    BookSilentTitle: `Silent Reading`,
    BookDuoFirstText: `¿Estás buscando una conexión auténtica? ¡Un Book Duo es perfecto para ti!`,
    BookDuoSecondText: `Simplemente elige un libro, selecciona el género y el rango de edad del compañero con el que te gustaría conectar, ¡y listo! Cuando alguien muestre interés, comenzarás una charla y organizarás los detalles de tu evento uno a uno.`,

    BookClubFirstText: `Descubre clubes de lectura en persona en tu área o en línea, organizados en entornos acogedores como cafés, bares o lugares cálidos, o a través de videoconferencia.`,
    BookClubSecondText: `Cada Ofellio Book Club acoge hasta 8 participantes, agrupados por edad para ofrecer una experiencia más cómoda y atractiva. La discusión será facilitada por un Ambassador de Ofellio, asegurando un ambiente dinámico e inclusivo
`,

    BookSilentFirstText: `Celebrados en un entorno relajante y cómodo, los Silent Readings ofrecen una escapada tranquila para hasta 10 lectores.`,
    BookSilentSecondText: `Dirigida por un Ambassador de Ofellio, cada sesión te invita a traer tu propio libro, leer en silencio y, si lo deseas, conectar con otros en un ambiente relajado.`,

    DuoBtnText: `Crea Book Duo`,
    ClubBtnText: `Crea Book Club`,
    SilentBtnText: `Crea Silent Reading`,

    JoinText: `Ofellio es una plataforma gratuita creada para quienes buscan conectar con otras personas y compartir pensamientos y emociones inspirados en un libro. Tu puerta a la comunidad, la amistad y conexiones genuinas.
`,
  },
  francais: {
    ReadText: `Cherchez des événements dans votre région ou en ligne`,
    Citytext: `Ville ou code postal`,
    // EventText: `Événements à`,
    EventText: `Derniers événements littéraires`,

    SeeAllEventText: `Voir tout `,
    SeeAllBookEventsText: `Voir tous les événements littéraires`,
    SoonAvailableText: `Télécharger l'application`,
    BookDuoTitle: `Book Duo`,
    BookClubTitle: `Book Club`,
    BookSilentTitle: `Silent Reading`,
    BookDuoFirstText: `Vous cherchez une connexion authentique ? Un Book Duo est parfait pour vous!`,
    BookDuoSecondText: `Choisissez simplement un livre, sélectionnez le genre et la tranche d'âge du partenaire avec lequel vous souhaitez vous connecter, et vous êtes prêt ! Lorsque quelqu'un montrera de l'intérêt, vous commencerez une conversation et organiserez les détails de votre événement one-to-one.`,

    BookClubFirstText: `Découvrez des clubs de lecture en personne dans votre région ou en ligne, organisés  dans des lieux chaleureux comme des cafés, des bars ou des espaces conviviaux, ou encore par visioconférence.`,
    BookClubSecondText: `Chaque Ofellio Book Club accueille jusqu'à 8 participants, regroupés par tranche d'âge pour une expérience plus confortable et engageante. La discussion sera animée par un Ambassador Ofellio, garantissant une atmosphère dynamique et inclusive.`,

    BookSilentFirstText: `Organisés dans un cadre relaxant et confortable, les Silent Readings offrent une parenthèse de tranquillité à jusqu’à 10 lecteurs.`,
    BookSilentSecondText: `Animée par un Ambassador Ofellio, chaque session vous invite à apporter votre propre livre, lire en silence et, si vous le souhaitez, échanger avec d’autres dans une atmosphère détendue`,

    DuoBtnText: `Créez Book Duo`,
    ClubBtnText: `Créez Book Club`,
    SilentBtnText: `Créez Silent Reading`,

    JoinText: `Ofellio est une plateforme gratuite conçue pour ceux qui souhaitent se connecter aux autres et partager des pensées et des émotions inspirées par un livre. Votre passerelle vers la communauté, l’amitié et des liens authentiques`,
  },
  nihongo: {
    ReadText: `あなたの地域のイベントやオンラインで探してください。`,
    Citytext: `市区町村または郵便`,
    // EventText: `イベント in`,
    EventText: `最新のブックイベント`,

    SeeAllEventText: `すべて見る`,
    SeeAllBookEventsText: `すべての読書イベントを見る`,
    SoonAvailableText: `アプリをダウンロード`,
    BookDuoTitle: `Book Duo`,
    BookClubTitle: `ブッククラブ`,
    BookSilentTitle: `Silent Reading`,
    BookDuoFirstText: `本物のつながりを求めていますか？Book Duoはあなたにぴったりです！`,
    BookDuoSecondText: `好きな本を選び、つながりたいパートナーの性別と年齢層を選んだら、準備完了です！誰かが興味を示したら、チャットを開始し、1対1のイベントの詳細を調整します。`,

    BookClubFirstText: `あなたの地域で開催される対面式のブッククラブやオンラインのブックク ラブを見つけましょう。カフェ、バー、居心地の良い会場などの温かみのある空間や、ビデオ会議を通じて開催されます。`,
    BookClubSecondText: `各Ofellio Book Clubは、より快適で魅力的な体験を提供するために、年齢層ごとに最大8名まで参加可能です。ディスカッションはOfellioのAmbassadorが進行し、活気があり誰もが参加しやすい雰囲気を作り出します。`,

    BookSilentFirstText: `リラックスできる快適な空間で開催されるSilent Readingsは、最大10名の読者に静かなひとときを提供します。`,
    BookSilentSecondText: `OfellioのAmbassadorが進行する各セッションでは、お気に入りの本を持ち寄り、静かに読書を楽しみ、必要に応じてリラックスした雰囲気の中で他の参加者と交流することができます。`,

    DuoBtnText: `Book Duoを作成`,
    ClubBtnText: `Book Club作成`,
    SilentBtnText: `Silent Reading作成`,

    JoinText: `Ofellioは、本を通じて人とつながり、思いや感情を共有したい方のための無料プラットフォームです。コミュニティ、友情、そして本物のつながりへの入り口`,
  },
  nederlands: {
    ReadText: `Zoek naar evenementen in jouw omgeving of online evenementen.`,
    Citytext: `Stad`,
    EventText: `Laatste boekevenementen`,
    SeeAllEventText: `Bekijk alle evenementen `,
    SeeAllBookEventsText: `Bekijk alle boekevenementen`,
    SoonAvailableText: `Download de app`,
    BookDuoTitle: `Book Duo`,
    BookClubTitle: `Boekenclub`,
    BookSilentTitle: `Silent Reading`,
    BookDuoFirstText: `Zoek je een persoonlijke verbinding? Een Book Duo is perfect voor jou!`,
    BookDuoSecondText: `Kies gewoon een boek naar keuze, selecteer het geslacht en leeftijdsbereik van de partner waarmee je wilt verbinden, en je bent klaar! Zodra iemand interesse toont, begin je een chat en regel je de details van je één-op-één evenement.`,
    BookClubFirstText: `Ontdek boekenclubs persoonlijk in jouw omgeving of online, gehost in een gezellige setting zoals cafés, bars of een gastvrije locatie of via videoconferentie.`,
    BookClubSecondText: `Elke Ofellio Boekenclub verwelkomt tot 8 deelnemers, gesorteerd op leeftijd om een comfortabelere en boeiendere ervaring te bieden. De discussie wordt begeleid door een Ofellio Ambassador, wat zorgt voor een levendige en inclusieve sfeer.`,
    BookSilentFirstText: `Gehouden in een ontspannende en comfortabele setting, bieden Stille Leessessies een vredige ontsnapping voor maximaal 10 lezers.`,
    BookSilentSecondText: `Geleid door een Ofellio Ambassador, nodigt elke sessie je uit om je eigen boek mee te nemen, rustig te lezen en optioneel verbinding te maken met anderen in een ontspannen sfeer`,
    DuoBtnText: `Maak Book Duo`,
    ClubBtnText: `Maak Boekenclub`,
    SilentBtnText: `Maak Stille Leessessie`,
    JoinText: `Ofellio is een gratis platform ontworpen voor iedereen die op zoek is naar verbinding met anderen en gedachten en gevoelens wil delen geïnspireerd door een boek. Jouw toegangspoort tot gemeenschap, vriendschap en echte verbindingen.`,
  },
  chinese: {
    ReadText: `在您所在地区或在线查找活动。`,
    Citytext: `城市`,
    EventText: `最新图书活动`,
    SeeAllEventText: `查看所有活动 `,
    SeeAllBookEventsText: `查看所有图书活动`,
    SoonAvailableText: `下载应用`,
    BookDuoTitle: `图书双人组`,
    BookClubTitle: `图书俱乐部`,
    BookSilentTitle: `Silent Reading`,
    BookDuoFirstText: `您正在寻找个人联系吗？图书双人组非常适合您！`,
    BookDuoSecondText: `只需选择您喜欢的图书，选择您想要联系的合作伙伴的性别和年龄范围，一切就绪！一旦有人表示兴趣，您将开始聊天并安排一对一活动的详细信息。`,
    BookClubFirstText: `在您所在地区或在线发现图书俱乐部，在舒适的场所举办，如咖啡馆、酒吧或欢迎的场所，或通过视频会议。`,
    BookClubSecondText: `每个Ofellio图书俱乐部欢迎最多8名参与者，按年龄分类，以提供更舒适和引人入胜的体验。讨论将由Ofellio Ambassador协助，确保活跃和包容的氛围。`,
    BookSilentFirstText: `在轻松舒适的环境中举行，静读会为最多10位读者提供宁静的避风港。`,
    BookSilentSecondText: `由Ofellio Ambassador领导，每次会议邀请您带上自己的书，安静地阅读，并可选地在轻松的氛围中与他人联系`,
    DuoBtnText: `创建图书双人组`,
    ClubBtnText: `创建图书俱乐部`,
    SilentBtnText: `创建静读会`,
    JoinText: `Ofellio是一个免费平台，专为希望与他人联系并分享由图书启发的想法和感受的任何人而设计。您通往社区、友谊和真实联系的入口。`,
  },
};
const HomePage2 = () => {
  const [isBookseller, setIsBookseller] = useState(""); // yes / no / ""

  const itemRefs = useRef([]);

  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const { selectedLanguage, setSelectedLanguage, lg } = useContext(LanguageContext); // Use the context

  const { user, setUser, setShowLoginM } = ChatState();

  const handleEventTypeClick = (book) => {
    if (book.name === "Book Club") {
      navigate(`/groupevent?bookid=${book._id}&searchbook=true`);
    } else if (book.name === "Book Duo") {
      navigate(`/meetorganizer?bookid=${book._id}&searchbook=true`);
    } else if (book.name === "Silent Reading") {
      navigate(`/silentreadingabout?bookid=${book._id}&searchbook=true`);
    } else {
      toast.error("Unknown event type");
    }
  };

  const handleEventTypeClickAuth = (eventType, link) => {
    // 1. Check if user is logged in
    if (!user || !user._id) {
      toast.error("You must be logged in to access this feature");
      return setShowLoginM(true);
      // navigate("/login"); // Redirect to login
    }

    // OLD CODE - Future use: Ambassador restriction check
    // // 2. Special checks for Book Club/Silent Reading
    // if (
    //   (eventType === "Book Club" || eventType === "Silent Reading") &&
    //   !user.isAmbassador
    // ) {
    //   toast.error("Only ambassadors can access this event type");
    //   setWShow(true);
    //   return; // Block navigation
    // }

    // NEW CODE: All users can create all event types
    // 2. Proceed with navigation
    if (link) {
      navigate(link);
      // Scroll to top on mobile devices when navigating to creation pages
      window.scrollTo({ top: 0, behavior: 'instant' });
    } else {
      console.error("No route defined for this event type:", eventType);
      toast.error("This event type is not available");
    }
  };
  // Model + Integration
  const [show, setShow] = useState(false); // For signup modal

  const [showLogin, setShowLogin] = useState(false); // For login modal
  const [showEmail, setShowEmail] = useState(false); // For login modal

  const handleClose = () => {
    setShow(false); // Close signup modal
    setShowLogin(false); // Close login modal
    setShowEmail(false);
    localStorage.setItem("modalClosedH", "true");
  };

  // Handle opening signup modal
  const handleShow = () => {
    setShowLoginM(true);
  };

  // Handle opening signup modal

  // Handle opening signup modal
  const handleShowEmail = () => {
    setShowEmail(true); // Open signup modal
    setShow(false);
    setShowLogin(false); // Close login modal if open
  };

  const handleEmailClose = () => {
    setShowLogin(false); // Close login modal
    setShowEmail(false);
    setShow(false);
  };

  // Handle opening login modal
  const handleLoginShow = () => {
    setShowEmail(false);
    setShowLogin(true); // Open login modal
    setShow(false);
  };

  // Handle closing login modal
  const handleLoginClose = () => {
    setShowLogin(false); // Close login modal
  };

  const navigate = useNavigate();

  const [fShow, setFShow] = useState(false); // For Forget Password modal
  const handleFClose = () => {
    setFShow(false); // Close signup modal
  };
  // Handle opening signup modal
  const handleFShow = () => {
    setFShow(true); // Open Forget Password  modal
    setShowLogin(false);
  };

  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const [passwordNewVisible, setPasswordNewVisible] = useState(false);

  const togglePasswordNewVisibility = () => {
    setPasswordNewVisible((prevState) => !prevState);
  };
  const [passwordNewVisible1, setPasswordNewVisible1] = useState(false);

  const togglePasswordNewVisibility1 = () => {
    setPasswordNewVisible1((prevState) => !prevState);
  };
  // ============== Integration =====================

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [seller, setSeller] = useState("");
  const [storeName, setStoreName] = useState("");
  const [storeAddress, setStoreAddress] = useState("");

  const [gender, setGender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [searchQueryHome, setSearchQueryHome] = useState(""); // For storing the search query (input value)
  const [suggestionsHome, setSuggestionsHome] = useState([]);
  const [bookCount, setBookCount] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [auth, setAuth] = useAuth();
  console.log("Auth from homepage2:", auth.user);
  const isAdmin = auth?.user?.isAdmin || false; // Ensure isAdmin is always a boolean
  const isAmbassador = auth?.user?.isAmbassador || false; // Ensure isAdmin is always a boolean

  // SignUP function
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isChecked) {
      toast.error(
        "Please agree to the terms and conditions before signing up."
      );
      return;
    }

    const passwordErrors = [];

    if (password.length < 8) {
      passwordErrors.push("Password must be at least 8 characters.");
    }
    if (!/[A-Z]/.test(password)) {
      passwordErrors.push(
        "Password must include at least one uppercase letter (A–Z)."
      );
    }
    if (!/[a-z]/.test(password)) {
      passwordErrors.push(
        "Password must include at least one lowercase letter (a–z)."
      );
    }
    if (!/[0-9]/.test(password)) {
      passwordErrors.push("Password must include at least one number (0–9).");
    }
    if (!/[!@#$%^&*]/.test(password)) {
      passwordErrors.push(
        "Password must include at least one special character (!@#$%^&*)."
      );
    }

    // 🔸 Show each missing requirement in a separate toast
    if (passwordErrors.length > 0) {
      passwordErrors.forEach((err) => toast.error(err));
      return;
    }

    try {
      const res = await axios.post("/api/v1/auth/register", {
        name,
        email,
        password,
        // city,
        // country,
        // gender,
        // dateOfBirth,
        seller: isBookseller, // <--- Use this

        storeName,
        storeAddress,
        language: selectedLanguage,
      });
      if (res && res.data.success) {
        toast.success(res.data && res.data.message);
        // ✅ Google Analytics Signup Event
        trackEvent("user_signup", {
            method: "Email", // Or "Google", "Facebook", etc.
            email: email,
            // city: city,
            // country: country,
          });
          console.log("✅ Google Analytics signup event sent:", {
            method: "Email",
            email,
            // city,
            // country,
          });

        setEmail("");
        setName("");
        setPassword("");
        // setCity("");
        // setCountry("");
        // setGender("");
        // setDateOfBirth("");
        setSeller("");
        setStoreName("");
        setIsBookseller("");
        setStoreAddress("");
        setIsChecked("");
        setShowEmail(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  // Login function
  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/api/v1/auth/login", {
        email,
        password,
      });
      if (res && res.data.success) {
        toast.success(res.data && res.data.message);
        setEmail("");

        setPassword("");
        setIsChecked("");
        setAuth({
          ...auth,
          user: res.data.user,
          token: res.data.token,
        });
        setUser(res.data.user);
        localStorage.setItem("auth", JSON.stringify(res.data));
        setShowLogin(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  // +=================== Google Login Signup ================

  const clientId =
    "500630261375-7capo8anko4108t790kb7o8juijd2a8j.apps.googleusercontent.com"; // Replace with your actual client ID

  const handleLoginSuccess = async (response) => {
    const idToken = response.credential;

    try {
      // Send the ID token to your backend
      const backendResponse = await axios.post("api/google-login", {
        token: idToken,
        language: selectedLanguage,
      });

      console.log("Backend Response:", backendResponse.data);

      // Store user data and token in localStorage
      // localStorage.setItem("user", JSON.stringify(backendResponse.data.user));
      // localStorage.setItem("token", backendResponse.data.token);

      setAuth({
        ...auth,
        user: backendResponse.data.user,
        token: backendResponse.data.token,
      });
      localStorage.setItem("auth", JSON.stringify(backendResponse.data));
      setShowLogin(false);

      toast.success("Login Successfully");
    } catch (error) {
      console.error("Error sending token to backend:", error);
      toast.error("Something went Wrong");
    }
  };

  // +=================== Google Login Signup ================

  // ================== Facebook Login SignUp ========================

  const handleFacebookLogin = () => {
    // Load the Facebook SDK if it's not loaded yet
    if (!window.FB) {
      loadFacebookSDK();
    } else {
      // Log in with Facebook
      window.FB.login(
        function (response) {
          if (response.authResponse) {
            console.log("Facebook login successful!", response);
            const { accessToken } = response.authResponse;

            // Send the access token to the backend for verification
            axios
              .post("api/facebook-login", { accessToken, language: selectedLanguage })
              .then((backendResponse) => {
                // Assuming the backend responds with user data and a token
                const { user, token } = backendResponse.data;

                // Set data in your auth context/state (if using Redux or Context)
                setAuth({
                  ...auth,
                  user: user,
                  token: token,
                });

                // Store the data in localStorage for persistence across page reloads
                localStorage.setItem(
                  "auth",
                  JSON.stringify(backendResponse.data)
                );
                toast.success("Login Successfully");

                // Optionally, hide the login modal or perform other UI updates
                setShowLogin(false);

                console.log("Backend response:", backendResponse.data);
              })
              .catch((err) => {
                toast.error("Something went Wrong");

                console.error("Error sending token to backend:", err);
              });
          } else {
            console.error("User cancelled login or did not fully authorize.");
          }
        },
        { scope: "email,public_profile" }
      );
    }
  };
  // Function to dynamically load the Facebook SDK
  const loadFacebookSDK = () => {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  };

  //================== Model + Integration ===========================

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#howitworks") {
      document
        .getElementById("howitworks")
        ?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);
  const [latestBooks, setLatestBooks] = useState([]);

  const [booksFromDB, setBooksFromDB] = useState([]);

  const settings = {
    // dots: true, // Show dots for navigation
    infinite: bookCount >= 3,
    speed: 500, // Transition speed
    slidesToShow: Math.min(3, bookCount),
    slidesToScroll: 1, // Move 1 book at a time
    draggable: true, // Allow drag functionality
    swipe: true, // Allow touch swipe
    arrows: false, // Hide default navigation arrows
    responsive: [
      {
        breakpoint: 768, // For screen widths <= 768px
        settings: {
          slidesToShow: Math.min(3, bookCount),
        },
      },
      {
        breakpoint: 450, // For screen widths <= 450px
        settings: {
          slidesToShow: Math.min(2, bookCount),
          centerMode: true, // Center the active slide
          centerPadding: "20px", // Padding around the center item
        },
      },
      {
        breakpoint: 390, // For screen widths <= 450px
        settings: {
          slidesToShow: Math.min(1, bookCount),
        },
      },
    ],
  };

  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <img
        src={leftArrow}
        alt="Previous"
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          left: "-30px", // Adjust position
          top: "50%",
          transform: "translateY(-50%) rotate(180deg)", // Rotate left arrow
          width: "15px",
          height: "15px",
          cursor: "pointer",
          zIndex: 1, // Ensure it's above other elements
        }}
        onClick={(e) => {
          e.stopPropagation(); // Prevent default event bubbling
          onClick(); // Move slider to left correctly
        }}
      />
    );
  };

  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <img
        src={rightArrow}
        alt="Next"
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          right: "-30px", // Adjust position
          left: "unset",
          top: "50%",
          transform: "translateY(-50%) rotate(0deg)",
          width: "15px",
          height: "15px",
          cursor: "pointer",
          zIndex: 1,
        }}
        onClick={(e) => {
          e.stopPropagation(); // Prevent default event bubbling
          onClick(); // Move slider to right correctly
        }}
      />
    );
  };
  const settingsd = {
    infinite: bookCount >= 3,
    speed: 500,
    slidesToShow: Math.min(6, bookCount), // default (desktop)
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    arrows: true,
    prevArrow: <CustomNextArrow />,
    nextArrow: <CustomPrevArrow />,
    rtl: false,
    variableWidth: false, // Keep false for consistent sizing
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: Math.min(5, bookCount),
        },
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: Math.min(4, bookCount),
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: Math.min(3, bookCount),
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(2, bookCount),
        },
      },
      {
        breakpoint: 480, // catches most mobiles
        settings: {
          slidesToShow: 2,
          arrows: false,
          draggable: true, // Allow drag functionality
          swipe: true, // Allow touch swipe
        },
      },
    ],
  };

  // OLD CODE - Future use: Ambassador restriction modal state
  // const [wShow, setWShow] = useState(false); // For ambassador restriction modal
  // const handleCloseW = () => {
  //   setWShow(false);
  // };
  // const handleShowW = () => {
  //   setWShow(true); // Open ambassador restriction modal
  // };

  const handleAmbasButtonClickModel = () => {
    localStorage.removeItem("modalClosedA");

    navigate("/ambassador", { state: { show: true } });
  };

  // Image serach
  const [ean, setEan] = useState("");
  const [imageSrc, setImageSrc] = useState(null);
  const [error, setError] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  // 📌 Handle suggestion click
  const handleSuggestionClick = (city) => {
    setSearchQuery(city);
    setSuggestions([]); // Hide dropdown
    navigate(`/booksandreview?city=${encodeURIComponent(city)}`);
  };

  // Location set IP address
  const [locationsss, setLocationsss] = useState("Loading...");
  const [userLatitude, setUserLatitude] = useState(null);
  const [userLongitude, setUserLongitude] = useState(null);

  useEffect(() => {
    const fetchLocation = () => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          // ✅ Save into state
          setUserLatitude(latitude);
          setUserLongitude(longitude);

          console.log("Latitude:", latitude); // Debugging log
          console.log("Longitude:", longitude); // Debugging log
          try {
            const response = await axios.get(
              `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=f38094deb4434dba86652d250a85311e`
            );
            // Debugging log to check the API response
            console.log("Geocoding API Response:", response.data);
            const components = response.data.results[0]?.components;
            const city =
              components?.city ||
              components?.town ||
              components?.village ||
              components?.hamlet ||
              components?.county ||
              components?.state_district ||
              components?.state;

            const countryCode = components?.country_code?.toUpperCase();

            console.log("City:", city); // Debugging log for city
            console.log("All location components:", components);

            console.log("Country Code:", countryCode); // Debu
            try {
              const booksResponse = await axios.post("api/v1/books/city", {
                longitude: longitude,
                latitude: latitude,
                radius: 50, // Default radius (miles)
              });
              console.log(booksResponse.data.data, "near by books!"); // Update state with books
              setBooksFromDB(booksResponse.data.data); // Update state with books
            } catch (error) {
              setBooksFromDB([]);
              console.error("Error fetching books:", error);
            }
            if (city && countryCode) {
              setLocationsss(`${city}, ${countryCode}`); // e.g., Lahore, PK
            } else if (countryCode) {
              setLocationsss(countryCode); // just PK
            } else {
              setLocationsss("Location not found");
            }
          } catch (error) {
            console.error("Error with reverse geocoding:", error);
            setLocationsss("Location not found");
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          setLocationsss("Permission denied or unavailable");
        }
      );
    };

    fetchLocation();
  }, []);

  const handleLocationClick = () => {
    if (locationsss !== "Location not found" && locationsss !== "Loading...") {
      const city = locationsss.split(",")[0];
      navigate(`/booksandreview`);
      // OLD CODE - Future use: Close ambassador modal when navigating
      // handleCloseW(true);

      // Scroll to top with a slight delay
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 1000);
    }
  };

  // ================== PAssowrd Forget ========================
  const { token } = useParams(); // 🏷 Get token from URL

  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  // ✅ Auto open modal if token exists
  useEffect(() => {
    if (token) {
      handleFShow(true); // Show modal
    }
  }, [token]);

  // 📩 Submit Password Reset Request
  const handleSubmitForget = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) {
      return toast.error("Password must be at least 8 characters long.");
    }
    if (newPassword !== confirmNewPassword) {
      return toast.error("Passwords do not match.");
    }

    try {
      const res = await axios.post(`api/v1/resetpassword/reset/${token}`, {
        newPassword,
        confirmNewPassword,
      });

      if (res.data.success) {
        toast.success(res.data.message);
        handleFClose(true); // Close modal
        setShowLoginM(true);
        navigate("/");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  // FORGETPASSWORD LINK SEND
  const [fPShow, setFPShow] = useState(false); // For Forget Password modal
  const handleFPClose = () => {
    setFPShow(false); // Close signup modal
  };
  // Handle opening signup modal
  const handleFPShow = () => {
    setFPShow(true); // Open Forget Password  modal
    setShowLogin(false);
  };

  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      return toast.error("Please enter your email");
    }

    try {
      setLoading(true);
      const res = await axios.post("api/v1/auth/forgot-password", { email });
      toast.success(res.data.message);
      handleFPClose(true);
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchLatestBooks = async () => {
      try {
        const response = await axios.get("api/v1/books/getlastesthomebooks");
        setLatestBooks(response.data.data);
        setBookCount(response.data.data.length);
      } catch (error) {
        console.error("Error fetching latest books:", error);
      }
    };

    fetchLatestBooks();
  }, []);

  const [showSuggestions, setShowSuggestions] = useState(false);
  const [query, setQuery] = useState("");
  const [onlineAllBooks, setOnlineAllBooks] = useState([]);

  useEffect(() => {
    const fetchOnlineAllBooks = async () => {
      try {
        const response = await axios.get("api/v1/books/getallonlinebooks");
        setOnlineAllBooks(response.data.data);
      } catch (error) {
        console.error("Error fetching latest books:", error);
      }
    };

    fetchOnlineAllBooks();
  }, []);

  const onlineBooks = onlineAllBooks.filter((book) => book.type === "On-line");

  useEffect(() => {
    if (highlightedIndex >= 0 && itemRefs.current[highlightedIndex]) {
      itemRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);
console.log(latestBooks, "latestBooks")
  return (
    <>
      <div
        className="bghihthome"
        style={{ backgroundColor: "#34C3C9", height: "650px" }}
      >
        <Header3 />
        <Container className=" scalmin1 mt-lg-5 clffassuusheder scalmin  mlamrajjliclinet">
          <div className=" d-flex flex-wrap justify-content-between    bookzipag  ">
            <div>
              <div
                className="fw-bold w-100 fontread"
                style={{
                  color: "#FFFFFF ",
                  fontSize: "35px",
                  lineHeight: "46px",
                  maxWidth: "600px",
                }}
              >
                {/* Read books, meet people, make connections. */}
                {homeRead[selectedLanguage]?.ReadText}
              </div>

              <div
                className="fw-normal w-100 my-sm-3 my-5 ftzevtt"
                style={{
                  maxWidth: "620px",
                  color: "#FFFFFF",
                  fontSize: "16px",
                  lineHeight: "25px",
                }}
              >
                <div>
                  {/* Whether you are an avid reader or just someone looking for
                  genuine connections, fuel your social life joining an Ofellio
                  Book Club, Book Duo and Silent Reading. */}
                  {homeHero[selectedLanguage]?.HeroText}
                </div>

                {/* <div className="my-sm-4 my-2">
                  Everything starts with a book, fuel your social life sharing a
                  common passion.
                </div> */}
              </div>
            </div>

            <div className="mt- d-none d-sm-block">
              <img
                style={{ maxWidth: "420px" }}
                className="  mt-1  mtpxclinet w-100 bookwid "
                src={require("../pages/image/bookhome2.png")}
                alt="logo"
                width="450"
                height="170"
              />
            </div>
          </div>
          <div className="text-center text-sm-start ">
            <div className="d-flex  align-items-center md:justify-start  justify-center mt-md-5 mt-4 gap-md-4 gap-2">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: "#ffffff", // white background
                  borderRadius: "9999px", // pill shape
                  padding: "10px 20px",
                  width: "fit-content", // makes width adapt to content
                  minWidth: "0",
                  color: "#34C3C9", // text + icon color
                  fontFamily: "Open Sans, sans-serif",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)", // optional subtle shadow
                  gap: "8px", // spacing between icons/text
                  height: "45px",
                  // maxWidth: omitted for responsiveness
                }}
                onClick={() => {
                  window.location.href = "/booksandreview";
                }}
              >
                <CalendarDays size={16} />
                <span>
                  {homeLook[selectedLanguage]?.SeeAllBookEventsText ||
                    "See all book events"}
                </span>
                <ChevronRight size={16} />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div className="scalmin1">
        <div className=" container d-flex flex-wrap scalmin mt-5  justify-content-between ">
          <div className="d-flex  gap-md-4 gap-0">
            <div
              className="fw-bold w-100   ftzevtn"
              style={{
                fontSize: "25px",
                lineHeight: "40.85px",
                maxWidth: "auto",
                color: "#34C3C9",
              }}
            >
              {/* Events near */}
              {homeLook[selectedLanguage]?.EventText}
            </div>
          </div>

          <div
            className="d-flex align-items-center gap-2"
            style={{
              border: "1px solid #FFFFFF",
              color: " #34C3C6",
            }}
          >
            <div
              className="fw-normal text-decoration-underline mobil"
              style={{
                cursor: "pointer",
                fontSize: "18px",
                lineHeight: "1.5",
              }}
              onClick={() => navigate("/booksandreview")}
            >
              {/* See all events */}
              {homeLook[selectedLanguage]?.SeeAllEventText}
            </div>
            <img
              className="d-sm-block d-none"
              src={require("../pages/image/arrowiconleft.png")}
              width="23"
              height="23"
              style={{ cursor: "pointer", height: "23px", width: "23px" }}
              onClick={() => navigate("/booksandreview")}
            />
          </div>
        </div>

        <div className="   home py-5  justify-content-center container  gap-xl-2 gap-1 align-items-center">
          <Slider {...settingsd}>
            {latestBooks.length === 0 ? (
              <p className="text-center text-muted">No books found lastest.</p>
            ) : (
              latestBooks.map((book, index) => {
                let spotsLeft =
                  Number(book?.maxAttendee) -
                  Number(book?.attendees?.length || 0);
                return (
                  <Card
                    key={index}
                    className="border-0 align-items-center d-flex custom-box-card"
                    style={{ width: "" }}
                  >
                    {book.image ? (
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          maxWidth: "145px",
                          margin: "0 auto",
                          aspectRatio: "145 / 200",
                        }}
                      >
                        <Card.Img
                          className="imgsizffe"
                          variant="top"
                          src={resolveBookImageUrl(book?.image)}
                          style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: "145px",
                            cursor: "pointer",
                            opacity:
                              book?.name == "Book Club"
                                ? spotsLeft === 0
                                  ? 0.3
                                  : 1
                                : 1,
                          }}
                          // onClick={() => navigate("/groupevent")}
                          onClick={() => {
                            const eventData = {
                              type: book.name,
                              location: book.city || "", // Use dynamic location
                              link: book.link || "",
                              title: book.title,
                              image: book.image,
                              author: book.author,
                              aboutBook: book.aboutBook,

                              pages: book.pageNumber,
                              genre: book.genre,
                              age: book.age,
                              city: book.city,
                              language: book.language,
                              gender: book.gender,
                              detail: book.description,
                              eventType: book.type,
                              createdAt: book?.dateInfo,
                              time: book?.timeTrack,
                              userId: book?.userId,
                              meetingLink: book?.meetingLink,
                              eventId: book._id,
                              attendees: book?.attendees,
                              LangLat: book?.location,
                            };
                            console.log("✅ Event Data:", eventData);
                            localStorage.setItem(
                              "eventDataNew",
                              JSON.stringify(eventData)
                            );
                            handleEventTypeClick(book);
                          }}
                        />
                        {spotsLeft === 0 && book?.name == "Book Club" && (
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%) rotate(301deg)",
                              color: "red",
                              fontSize: "32px",
                              fontWeight: "bold",
                              border: "2px solid red",
                              padding: "5px 15px",
                              textTransform: "uppercase",
                              backgroundColor: "rgba(255,255,255,0.6)",
                              pointerEvents: "none",
                            }}
                          >
                            FULL
                          </div>
                        )}
                      </div>
                    ) : book.name === "Silent Reading" ? (
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          maxWidth: "145px",
                          margin: "0 auto",
                          aspectRatio: "145 / 200",
                        }}
                      >
                        <Card.Img
                          className="imgsdsddssize157"
                          variant="top"
                          src={require("./image/book7.jpg")}
                          style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: "145px",
                            cursor: "pointer",
                          }}
                          // onClick={() => navigate("/groupevent")}
                          onClick={() => {
                            const eventData = {
                              type: book.name,
                              location: book.city || "", // Use dynamic location
                              link: book.link || "",
                              title: book.title,
                              image: book.image,
                              author: book.author,
                              aboutBook: book.aboutBook,

                              pages: book.pageNumber,
                              genre: book.genre,
                              age: book.age,
                              city: book.city,
                              language: book.language,
                              gender: book.gender,
                              detail: book.description,
                              eventType: book.type,
                              createdAt: book?.dateInfo,
                              time: book?.timeTrack,
                              userId: book?.userId,
                              meetingLink: book?.meetingLink,
                              eventId: book._id,
                              attendees: book?.attendees,
                              LangLat: book?.location,
                              // type:
                              //   book.type.toLowerCase() === "on-line"
                              //     ? "Book Duo"
                              //     : "Book Club", // ✅ Condition Added
                            };
                            console.log("✅ Event Data:", eventData);
                            localStorage.setItem(
                              "eventDataNew",
                              JSON.stringify(eventData)
                            );
                            handleEventTypeClick(book);
                          }}
                        />
                        {spotsLeft === 0 && book?.name == "Silent Reading" && (
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%) rotate(301deg)",
                              color: "red",
                              fontSize: "32px",
                              fontWeight: "bold",
                              border: "2px solid red",
                              padding: "5px 15px",
                              textTransform: "uppercase",
                              backgroundColor: "rgba(255,255,255,0.6)",
                              pointerEvents: "none",
                            }}
                          >
                            FULL
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "145px",
                          margin: "0 auto",
                          aspectRatio: "145 / 200",
                          cursor: "pointer",
                          backgroundColor: "#e0e0e0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#777",
                        }}
                        onClick={() => {
                          const eventData = {
                            type: book.name,
                            location: book.city || "", // Use dynamic location
                            link: book.link || "",
                            title: book.title,
                            image: book.image,
                            author: book.author,
                            aboutBook: book.aboutBook,

                            pages: book.pageNumber,
                            genre: book.genre,
                            age: book.age,
                            city: book.city,
                            language: book.language,
                            gender: book.gender,
                            detail: book.description,
                            eventType: book.type,
                            createdAt: book?.dateInfo,
                            time: book?.timeTrack,
                            userId: book?.userId,
                            meetingLink: book?.meetingLink,
                            eventId: book._id,
                            attendees: book?.attendees,
                            LangLat: book?.location,
                          };
                          console.log("✅ Event Data:", eventData);
                          localStorage.setItem(
                            "eventDataNew",
                            JSON.stringify(eventData)
                          );
                          // handleEventTypeClick(book.name);
                          handleEventTypeClick(book);
                        }}
                      >
                        No Image
                      </div>
                    )}
                    <Card.Body className="pt-1 px-0 w-100 pb-0 text-left  align-items-start">
                      <Card.Title
                        className="text-left ftzgern inline-block mt-2 m-0"
                        style={{
                          backgroundColor:
                            book.name === "Book Club"
                              ? "#D9EAD3"
                              : book.name === "Silent Reading"
                              ? "#DBEAFE"
                              : book.name === "Book Duo"
                              ? "#FFE4E6"
                              : "transparent", // default bg
                          color:
                            book.name === "Book Club"
                              ? "#1F5130"
                              : book.name === "Silent Reading"
                              ? "#1E3A8A"
                              : book.name === "Book Duo"
                              ? "#BE123C"
                              : "#000000", // default text color
                          fontFamily: "Inter",
                          fontWeight: "600",
                          cursor: "pointer",
                          borderRadius: "50px", // optional: make label pill-like
                          padding: "4px 8px", // optional: add spacing
                          display: "inline-block", // keeps label compact
                          fontSize: "14px",
                        }}
                        onClick={() => handleEventTypeClick(book)}
                      >
                        {book?.name}
                      </Card.Title>

                      <Card.Title
                        className=" w-100 ftztitle my-2 "
                        style={{
                          color: "#000000",
                          fontSize: "18px",
                          fontFamily: "Inter",
                          fontWeight: "700",

                          marginTop: "0px",

                          marginBottom: "0px",
                        }}
                      >
                        {book?.name === "Silent Reading"
                          ? lg?.yourOwnBook || "Your Own Book"
                          : book.title.length > 10
                          ? book.title.slice(0, 13) + "..." // Truncate Title
                          : book.title}
                      </Card.Title>

                      <Card.Text
                        className="w-100 mt-1 ftzgern m-0"
                        style={{
                          color: "#4B5563", // Tailwind gray-600
                          fontSize: "14px",
                          fontFamily: "Open Sans",
                          fontWeight: "500",
                          lineHeight: "20px",
                          maxWidth: "203px",
                        }}
                      >
                        {/* Date */}
                        <div className="d-flex align-items-center mb-1">
                          <CalendarDays
                            size={16}
                            style={{ marginRight: "6px", color: "#6B7280" }}
                          />
                          {book?.name === "Book Duo"
                            ? "TBD"
                            : `${book?.dateInfo?.dayName}, ${book?.dateInfo?.day} ${book?.dateInfo?.month} ${book?.dateInfo?.year}`}
                        </div>

                        <div className="d-flex align-items-center">
                          {book?.type === "On-line" ? (
                            <>
                              <Video
                                size={16}
                                style={{ marginRight: "6px", color: "#6B7280" }}
                              />
                              <span>Online</span>
                            </>
                          ) : (
                            <>
                              <MapPin
                                size={16}
                                style={{ marginRight: "6px", color: "#6B7280" }}
                              />
                              <span>
                                {book?.city?.length > 12
                                  ? book.city.substring(0, 12) + "..."
                                  : book?.city}
                              </span>
                            </>
                          )}
                        </div>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                );
              })
            )}
            {/* ))} */}

            {/* </div> */}
            {/* <img
            src={require("./image/moveimgarrow.png")}
            width="8"
            height="18"
          /> */}
          </Slider>
        </div>
        {/* Coursoll  */}
        <div className="my-5 d-none scalmin home  ">
          <Slider {...settings}>
            {/* {books.map((book, idx) => ( */}
            {latestBooks.length === 0 ? (
              <p className="text-center text-muted">
                No books found near your location.
              </p>
            ) : (
              latestBooks?.map((book, idx) => {
                console.log(book, "bookbook");
                let spotsLeft =
                  Number(book?.maxAttendee) -
                  Number(book?.attendees?.length || 0);
                return (
                  <div key={idx} className="d-flex justify-content-center">
                    <Card
                      className="border-0 custom-box-card align-items-center"
                      style={{ width: "auto" }}
                    >
                      {book.image ? (
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            maxWidth: "145px",
                            margin: "0 auto",
                            aspectRatio: "145 / 200",
                          }}
                        >
                          <Card.Img
                            className="imgreresizffe"
                            variant="top"
                            src={`${BASE_URL}${book.image}`}
                            style={{
                              width: "100%",
                              height: "auto",
                              maxWidth: "145px",
                              cursor: "pointer",
                              opacity:
                                book?.name == "Book Club"
                                  ? spotsLeft === 0
                                    ? 0.3
                                    : 1
                                  : 1, // Dim image when full
                            }}
                            onClick={() => {
                              const eventData = {
                                type: book.name,
                                location: book.city || "",
                                link: book.link || "",
                                title: book.title,
                                image: book.image,
                                author: book.author,
                                aboutBook: book.aboutBook,
                                pages: book.pageNumber,
                                genre: book.genre,
                                age: book.age,
                                city: book.city,
                                language: book.language,
                                gender: book.gender,
                                detail: book.description,
                                eventType: book.type,
                                createdAt: book?.dateInfo,
                                time: book?.timeTrack,
                                userId: book?.userId,
                                meetingLink: book?.meetingLink,
                                eventId: book._id,
                                attendees: book?.attendees,
                                LangLat: book?.location,
                              };
                              console.log("✅ Event Data:", eventData);
                              localStorage.setItem(
                                "eventDataNew",
                                JSON.stringify(eventData)
                              );
                              handleEventTypeClick(book);
                            }}
                          />

                          {/* ✅ Full Watermark Overlay */}
                          {spotsLeft === 0 && book?.name == "Book Club" && (
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform:
                                  "translate(-50%, -50%) rotate(301deg)",
                                color: "red",
                                fontSize: "32px",
                                fontWeight: "bold",
                                border: "2px solid red",
                                padding: "5px 15px",
                                textTransform: "uppercase",
                                backgroundColor: "rgba(255,255,255,0.6)",
                                pointerEvents: "none",
                              }}
                            >
                              FULL
                            </div>
                          )}
                        </div>
                      ) : book.name === "Silent Reading" ? (
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            maxWidth: "145px",
                            margin: "0 auto",
                            aspectRatio: "145 / 200",
                          }}
                        >
                          <Card.Img
                            className="imgsize157"
                            variant="top"
                            src={require("./image/book7.jpg")}
                            style={{
                              width: "100%",
                              height: "auto",
                              maxWidth: "145px",
                              cursor: "pointer",
                            }}
                            // onClick={() => navigate("/groupevent")}
                            onClick={() => {
                              const eventData = {
                                type: book.name,
                                location: book.city || "", // Use dynamic location
                                link: book.link || "",
                                title: book.title,
                                image: book.image,
                                author: book.author,
                                aboutBook: book.aboutBook,

                                pages: book.pageNumber,
                                genre: book.genre,
                                age: book.age,
                                city: book.city,
                                language: book.language,
                                gender: book.gender,
                                detail: book.description,
                                eventType: book.type,
                                createdAt: book?.dateInfo,
                                time: book?.timeTrack,
                                userId: book?.userId,
                                meetingLink: book?.meetingLink,
                                eventId: book._id,
                                attendees: book?.attendees,
                                LangLat: book?.location,
                                // type:
                                //   book.type.toLowerCase() === "on-line"
                                //     ? "Book Duo"
                                //     : "Book Club", // ✅ Condition Added
                              };
                              console.log("✅ Event Data:", eventData);
                              localStorage.setItem(
                                "eventDataNew",
                                JSON.stringify(eventData)
                              );
                              handleEventTypeClick(book);
                            }}
                          />
                          {spotsLeft === 0 &&
                            book?.name == "Silent Reading" && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform:
                                    "translate(-50%, -50%) rotate(301deg)",
                                  color: "red",
                                  fontSize: "32px",
                                  fontWeight: "bold",
                                  border: "2px solid red",
                                  padding: "5px 15px",
                                  textTransform: "uppercase",
                                  backgroundColor: "rgba(255,255,255,0.6)",
                                  pointerEvents: "none",
                                }}
                              >
                                FULL
                              </div>
                            )}
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "145px",
                            height: "200px",
                            cursor: "pointer",
                            backgroundColor: "#e0e0e0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#777",
                          }}
                          onClick={() => {
                            const eventData = {
                              type: book.name,
                              location: book.city || "", // Use dynamic location
                              link: book.link || "",
                              title: book.title,
                              image: book.image,
                              author: book.author,
                              pages: book.pageNumber,
                              aboutBook: book.aboutBook,

                              genre: book.genre,
                              age: book.age,
                              city: book.city,
                              language: book.language,
                              gender: book.gender,
                              detail: book.description,
                              eventType: book.type,
                              createdAt: book?.dateInfo,
                              time: book?.timeTrack,
                              userId: book?.userId,
                              meetingLink: book?.meetingLink,
                              eventId: book._id,
                              attendees: book?.attendees,
                              LangLat: book?.location,
                              // type:
                              //   book.type.toLowerCase() === "on-line"
                              //     ? "Book Duo"
                              //     : "Book Club", // ✅ Condition Added
                            };
                            console.log("✅ Event Data:", eventData);
                            localStorage.setItem(
                              "eventDataNew",
                              JSON.stringify(eventData)
                            );
                            handleEventTypeClick(book);
                          }}
                        >
                          No Image
                        </div>
                      )}
                      <Card.Body className="pt-1 px-0 w-100 pb-0 text-left">
                        <Card.Title
                          className="text-left ftzgern mt-2 m-0"
                          style={{
                            backgroundColor:
                              book.name === "Book Club"
                                ? "#D9EAD3"
                                : book.name === "Silent Reading"
                                ? "#DBEAFE"
                                : book.name === "Book Duo"
                                ? "#FFE4E6"
                                : "transparent", // default bg
                            color:
                              book.name === "Book Club"
                                ? "#1F5130"
                                : book.name === "Silent Reading"
                                ? "#1E3A8A"
                                : book.name === "Book Duo"
                                ? "#BE123C"
                                : "#000000", // default text color
                            fontFamily: "Inter",
                            fontWeight: "600",
                            cursor: "pointer",
                            borderRadius: "50px", // optional: make label pill-like
                            padding: "4px 8px", // optional: add spacing
                            display: "inline-block", // keeps label compact
                            fontSize: "14px",
                          }}
                          onClick={() => handleEventTypeClick(book)}
                        >
                          {book?.name}
                        </Card.Title>

                        <Card.Title
                          className=" w-100 ftztitle my-2 "
                          style={{
                            color: "#000000",
                            fontSize: "18px",
                            fontFamily: "Inter",
                            fontWeight: "700",

                            marginTop: "0px",

                            marginBottom: "0px",
                          }}
                        >
                          {book?.name === "Silent Reading"
                            ? lg?.yourOwnBook || "Your Own Book"
                            : book.title.length > 10
                            ? book.title.slice(0, 10) + "..." // Truncate Title
                            : book.title}
                        </Card.Title>

                        <Card.Text
                          className="w-100 mt-1 ftzgern m-0"
                          style={{
                            color: "#4B5563", // Tailwind gray-600
                            fontSize: "14px",
                            fontFamily: "Open Sans",
                            fontWeight: "500",
                            lineHeight: "20px",
                            maxWidth: "203px",
                          }}
                        >
                          {/* Date */}
                          <div className="d-flex align-items-center mb-1">
                            <CalendarDays
                              size={16}
                              style={{ marginRight: "6px", color: "#6B7280" }}
                            />
                            {book?.name === "Book Duo"
                              ? "TBD"
                              : `${book?.dateInfo?.dayName}, ${book?.dateInfo?.day} ${book?.dateInfo?.month} ${book?.dateInfo?.year}`}
                          </div>

                          <div className="d-flex align-items-center">
                            {book?.type === "On-line" ? (
                              <>
                                <Video
                                  size={16}
                                  style={{
                                    marginRight: "6px",
                                    color: "#6B7280",
                                  }}
                                />
                                <span>Online</span>
                              </>
                            ) : (
                              <>
                                <MapPin
                                  size={16}
                                  style={{
                                    marginRight: "6px",
                                    color: "#6B7280",
                                  }}
                                />
                                <span>
                                  {book?.city?.length > 12
                                    ? book.city.substring(0, 12) + "..."
                                    : book?.city}
                                </span>
                              </>
                            )}
                          </div>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                );
              })
            )}
          </Slider>
        </div>

        <div className="mt-5 bg-[#f2f2f2]   scalmin " id="howitworks">
          <div className=" sectionh pb-3">
            <div className="container">
              <h2
                className="  fw-bold sm:text-[29px] text-[22px] !mb-3  "
                style={{
                  textAlign: "center",
                  color: "#34c3c9",
                }}
              >
                {lg?.howOfellioWorks || "How Ofellio works"}
              </h2>
              <p
              className="!mb-10"
                style={{
                  textAlign: "center",

                  color: "#374151",

          
                  fontSize: "16px",
                  lineHeight: "1.6",
                }}
              >
                {lg?.howItWorksDesc || "Discover new ways to connect through books — whether one-on-one, in a group, or in peaceful silent reading sessions."}
              </p>
              <div className="d-flex conta flex-wrap  gap-4 mt-4 mb-3 justify-content-center ">
                <div className="w-100 mwhpd card-boxh">
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    <Users size={48} color="#34c3c9" />
                  </div>

                  <div className="d-flex align-items-center justify-content-center">
                    <div className="mb-md-2 mb-sm-2 fw-bold bookduo card-titleh">
                      {lg?.bookDuoTitle || "Book Duo"}
                    </div>
                  </div>

                  <div className="fw-normal text-dark w-100  bookduoftz card-texth">
                    {lg?.bookDuoDesc || "Looking for a personal connection? Choose a book, select a partner's age and gender preference, and start a one-to-one literary journey."}
                  </div>

                  <div className="text-center mt-3">
                    <button
                      className="fs-18 btngropwid fw600 border-0 mt-2 rounded-1 !text-white text-center w-100 card-btnh"
                      onClick={() =>
                        handleEventTypeClickAuth("Book Duo", "/createmeetup")
                      }
                    >
                      {homeLook[selectedLanguage]?.DuoBtnText}
                    </button>
                  </div>
                </div>
                <div className="w-100 mwhpd card-boxh">
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    <Coffee size={48} color="#34c3c9" />
                  </div>

                  <div className="d-flex align-items-center justify-content-center">
                    <div className="mb-md-2 mb-sm-2 fw-bold bookduo card-titleh">
                      {lg?.bookClubTitle || "Book Club"}
                    </div>
                  </div>

                  <div
                    className="fw-normal text-dark w-100  bookduoftz card-texth"
                    style={{ wordSpacing: "5px" }}
                  >
                    {lg?.bookClubDesc || "Join welcoming in-person or online book clubs hosted in cozy settings. Each group is facilitated by an Ambassador to ensure a lively and inclusive experience."}
                  </div>

                  <div className="text-center mt-3">
                    <button
                      className="fs-18 btngropwid fw600 border-0 mt-2 rounded-1 !text-white text-center w-100 card-btnh"
                      onClick={() =>
                        handleEventTypeClickAuth("Book Club", "/booksdetails")
                      }
                    >
                      {homeLook[selectedLanguage]?.ClubBtnText}
                    </button>
                  </div>
                </div>
                <div className="w-100 mwhpd card-boxh">
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    <BookOpen size={48} color="#34c3c9" />
                  </div>

                  <div className="d-flex align-items-center justify-content-center">
                    <div className="mb-md-2 mb-sm-2 fw-bold bookduo card-titleh">
                      {lg?.silentReadingTitle || "Silent reading"}{" "}
                    </div>
                  </div>

                  <div
                    className="fw-normal text-dark w-100 bookduoftz card-texth"
                    style={{ wordSpacing: "5px" }}
                  >
                    {lg?.silentReadingDesc || "Enjoy peaceful silent reading sessions. Bring your own book, relax, and share the quiet joy of reading together."}
                  </div>

                  <div className="text-center mt-3">
                    <button
                      className="fs-18 btngropwid fw600 border-0 mt-2 rounded-1 !text-white text-center w-100 card-btnh"
                      onClick={() =>
                        handleEventTypeClickAuth(
                          "Silent Reading",
                          "/silentreading"
                        )
                      }
                    >
                      {homeLook[selectedLanguage]?.SilentBtnText}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className=" fw-normal container d-none fs-18 my-3 mllft mlhowwo text-center  textcntr  ftzevtt"
            style={{
              lineHeight: "27.24px",
            }}
          >
            {lg?.exploreThe || "Explore the"}{" "}
            <span
              className="text-decoration-underline "
              style={{ color: "#34C3C9", cursor: "pointer" }}
              onClick={() => navigate("/booksandreview")}
            >
              {" "}
              {lg?.existingEvents || "existing events"}{" "}
            </span>{" "}
            {lg?.or || "or"}
            <span
              className="text-decoration-underline "
              style={{ color: "#34C3C9", cursor: "pointer" }}
              onClick={() => navigate("/booksandreview#booksandreviewsboxws")}
            >
              {" "}
              {lg?.createYourOwn || "create your own"}{" "}
            </span>{" "}
            !
          </div>

          {(!auth?.user || !auth?.user?._id) && (
            <div className="w-full relative">
              <div className="container mx-auto px-4 py-10 md:py-14">
                <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
                  {/* Left Content */}
                  <div className="flex-1 text-center md:text-left">
                    <div className="flex items-center justify-center gap-3 mb-4">
                      <div className="p-2 rounded-xl" style={{ backgroundColor: "rgba(52, 195, 201, 0.1)" }}>
                        <BookOpen size={32} color="#34C3C9" />
                      </div>
                      <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                        {lg?.joinOfellio || "Join Ofellio"}
                      </h2>
                    </div>
                    <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-6 md:mb-8 max-w-2xl mx-auto md:mx-0 font-medium">
                      {homeLook[selectedLanguage]?.JoinText}
                    </p>
                    <button
                      onClick={handleShow}
                      className="group relative px-8 py-3.5 text-white font-semibold rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 overflow-hidden"
                      style={{
                        backgroundColor: "#34C3C9",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#2BB3BA";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#34C3C9";
                      }}
                    >
                      <span className="relative z-10 flex items-center gap-2">
                        {lg?.signUp || "Sign up"}
                        <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                      </span>
                      <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity"></div>
                    </button>
                  </div>
                  

                </div>
              </div>
            </div>
          )}
          <div className="d-sm-flex gap-3  container  align-items-center my-3  justify-content-right text-lg-end text-center justify-content-lg-end mb-0 pb-3">
            <div
              className="fw-bold mx-sm-2 my-2 my-sm-0  fontmobil"
              style={{ color: "#34C3C9", fontSize: "17px" }}
            >
              {homeLook[selectedLanguage]?.SoonAvailableText ||
                "Download the app"}
            </div>
            <div>
              <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
                <img
                  className="bg-black mx-auto mx-sm-0 rounded-4 app-store-button"
                  src={require("./image/app1.png")}
                  style={{ cursor: "pointer" }}
                  alt="Download on the App Store"
                />
              </a>
            </div>

            <div>
              <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
                <img
                  className="bg-black mx-auto mx-sm-0 mt-2 mt-sm-0 rounded-4 app-store-button"
                  src={require("./image/fullplay.png")}
                  style={{ cursor: "pointer" }}
                  alt="Get it on Google Play"
                />
              </a>
            </div>

            {/* <div
            className="bg-black w-100 rounded-3 border-white"
            style={{
              maxWidth: "190px",
              height: "64px",
            }}
          >
            <div className="d-flex  align-items-center">
              <img
                className="mx-2  py-2 my-1"
                src={require("./image/playstore.png")}
              />
              <div className="mt-3">
                <div
                  className="fw600 text-white "
                  style={{ fontSize: "13px", lineHeight: "2px" }}
                >
                  Available on
                </div>
                <div className="fw600 text-white " style={{ fontSize: "27px" }}>
                  Play Store
                </div>
              </div>
            </div>
          </div> */}
          </div>
        </div>
      </div>

      <Footer2 />

      {/* Modal Component */}
      <Modal show={show} onHide={handleClose} centered className="custom-modal">
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtn "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleClose}
          />
        </Modal.Header>

        <Modal.Title
          className="text-center text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          Create an account
        </Modal.Title>

        <Modal.Body className="modelbody">
          <div className="text-center">
            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal  mt-4 my-1 position-relative modelacc  btnhover"
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
              // onClick={() =>
              //   (window.location.href = "http://localhost:8080/auth/google")
              // }
            >
              <GoogleOAuthProvider clientId={clientId}>
                <div className="googlelogin ">
                  <GoogleLogin
                    onSuccess={handleLoginSuccess}
                    onError={() => console.log("Login Failed")}
                  />
                </div>
              </GoogleOAuthProvider>
              <div className="mtgoole" style={{ marginTop: "-40px" }}>
                <img
                  className=" position-absolute lefttt"
                  src={require("../components/image/google.png")}
                  alt="Google"
                />
                Continue with Google
              </div>
            </Button>

            <Button
              variant="light"
              className="w-100 fs-5 rounded-4 fw-normal my-1 position-relative  modelacc  btnhover"
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",

                color: "#000000",
                lineHeight: "27.24px",
              }}
              onClick={handleFacebookLogin}
            >
              <img
                className=" position-absolute lefttt"
                src={require("../components/image/facebook.png")}
                alt="Facebook"
              />{" "}
              Continue with Facebook
            </Button>

            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal my-1 position-relative modelacc   btnhover "
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <img
                className=" position-absolute lefttt"
                src={require("../components/image/apple.png")}
                alt="Apple"
              />
              Continue with Apple
            </Button>

            <Button
              variant="light"
              className="w-100 my-1 rounded-4  fs-5 fw-normal position-relative modelacc    btnhover"
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",

                color: "#000000",
                lineHeight: "27.24px",
              }}
              onClick={handleShowEmail}
            >
              <img
                className=" position-absolute lefttt"
                src={require("../components/image/email.png")}
                alt="Email"
              />
              Continue with E-mail
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <div className="text-center w-100">
            <div className="mt-2 mb-3 fs-4 fw-bold modeltitle ">
              Already a member?
            </div>
            <Button
              className="fs-5 text-white loginbtnwidmodel border-0 fw-bold w-100 "
              style={{
                backgroundColor: "#34C3C9",
                lineHeight: "27.24px",
                color: "#000000",
                maxWidth: "231px",
                height: "44px",
              }}
              onClick={handleLoginShow} // Show login modal
            >
              Login
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* Login Modal */}
      <Modal
        show={showLogin}
        onHide={handleLoginClose}
        centered
        className="custom-modal custom-modallogin"
      >
        <Modal.Header className="border-0">
          <img
            className="border-0 closebtn"
            src={require("../components/image/close.png")}
            alt="close"
            onClick={handleLoginClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center fw-bold modeltitle mt-3"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
            color: "#000000",
          }}
        >
          Login
        </Modal.Title>
        <Modal.Body className="modelbody">
          <div className="text-center">
            <form className="textleft  margg" onSubmit={handleSubmitLogin}>
              <div className="mb-3">
                <label
                  htmlFor="email"
                  className="form-label fs-5 ftlink text-left"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  Email
                </label>
                <input
                  type="email"
                  className="form-control fs-5 ftzevtt rounded-4 placeholder-login"
                  id="email"
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "56px",
                    fontWeight: "600",
                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>
              <div className="mb-3">
                <div className="d-flex  justify-content-between">
                  <label
                    htmlFor="password"
                    className="form-label ftlink fs-5"
                    style={{
                      color: "#000000",
                      lineHeight: "27.24px",
                      fontWeight: "600",
                    }}
                  >
                    Password
                  </label>
                  <label
                    htmlFor="password"
                    className="form-label fontmobil fw-normal "
                    style={{
                      color: "#000000",
                      lineHeight: "24.51px",
                      fontSize: "18px",
                      cursor: "pointer",
                    }}
                    // onClick={() => navigate("/forgot-password")}
                    onClick={handleFPShow}
                  >
                    Forgot Password?
                  </label>
                </div>

                <input
                  type="password"
                  className="form-control fs-5 ftzevtt rounded-4 placeholder-login"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "56px",
                    fontWeight: "600",
                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>
              <div className="form-check">
                <input
                  className="form-check-input rounded-0 placeholder-login"
                  type="checkbox"
                  // required
                  defaultValue
                  id="flexCheckDefault"
                  style={{ border: "1px solid #6D6D6D " }}
                />
                <label
                  className="form-check-label fs-6"
                  htmlFor="flexCheckDefault"
                  style={{
                    color: "#4C4C4C",
                    fontWeight: "600",
                    lineHeight: "21.79px",
                  }}
                >
                  Keep me signed in
                </label>
              </div>
              <div className="text-center mt-3">
                <Button
                  type="submit"
                  className="fs-5 text-white loginbtnwidmodel border-0 fw-bold w-100 "
                  style={{
                    backgroundColor: "#34C3C9",
                    lineHeight: "27.24px",
                    color: "#000000",
                    maxWidth: "231px",
                    height: "44px",
                  }}
                  onClick={handleLoginShow} // Show login modal
                >
                  Login
                </Button>
              </div>

              <div className="d-flex justify-content-center gap-2 mt-4">
                <div
                  className="border-1 w-100 "
                  style={{
                    maxWidth: "255px",
                    border: "1.4px solid #969696",

                    height: "1.4px",
                  }}
                ></div>

                <div
                  className="ftzcopy   fs-6 text-center"
                  style={{
                    color: "#595959",

                    fontFamily: "Open Sans",
                    fontWeight: "600",
                    lineHeight: "21.79px",
                    marginTop: "-10px",
                  }}
                >
                  or
                </div>
                <div
                  className="border-1 w-100 "
                  style={{
                    maxWidth: "255px",
                    border: "1.4px solid #969696",

                    height: "1.4px",
                  }}
                ></div>
              </div>
            </form>

            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal mtlow mt-4 my-1 position-relative modelacclogin btnhover"
              style={{
                maxWidth: "539px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
              // onClick={handleLoginSuccess}
            >
              <GoogleOAuthProvider clientId={clientId}>
                <div className="googlelogin ">
                  <GoogleLogin
                    onSuccess={handleLoginSuccess}
                    onError={() => console.log("Login Failed")}
                  />
                </div>
              </GoogleOAuthProvider>
              <div className="mtgoole" style={{ marginTop: "-40px" }}>
                <img
                  className=" position-absolute lefttt lefttt22"
                  src={require("../components/image/google.png")}
                  alt="Google"
                />
                Continue with Google
              </div>
            </Button>

            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal my-1 position-relative modelacclogin btnhover "
              style={{
                maxWidth: "539px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <img
                className=" position-absolute lefttt lefttt22"
                src={require("../components/image/apple.png")}
                alt="Apple"
              />
              Continue with Apple
            </Button>
            <Button
              variant="light"
              className="w-100 fs-5 rounded-4 fw-normal my-1 position-relative modelacclogin btnhover"
              style={{
                maxWidth: "539px",
                height: "56px",
                border: "1px solid #6D6D6D",

                color: "#000000",
                lineHeight: "27.24px",
              }}
              onClick={handleFacebookLogin}
            >
              <img
                className=" position-absolute lefttt lefttt22"
                src={require("../components/image/facebook.png")}
                alt="Facebook"
              />
              Continue with Facebook
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* EMAIL SING UP */}
      <Modal
        show={showEmail}
        onHide={handleEmailClose}
        centered
        className="custom-modal custom-modalsign modelaginsignup "
      >
        <Modal.Header className="border-0">
          <img
            className="border-0 closebtn closbtnagsig top-0 "
            src={require("../components/image/close.png")}
            alt="close"
            onClick={handleEmailClose}
            style={{ marginTop: "32px" }}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center fw-bold  modeltitle  modeltitagsign"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
            color: "#000000",
            marginTop: "-15px",
          }}
        >
          Sign up
        </Modal.Title>
        <Modal.Body className="modelbody pb-md-0 pt-2 pb-0">
          <div className="text-center">
            <form className="textleft margg" onSubmit={handleSubmit}>
              <div className="mb-2">
                <label
                  htmlFor="email"
                  className="form-label mb-1 fs-5 ftlink text-left"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  E-mail
                </label>
                <input
                  type="email"
                  className="form-control w-100 rounded-0 ftzevtt fs-5 placeholder-login"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "45px",
                    fontWeight: "600",
                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>

              <div className="mb-2">
                <label
                  htmlFor="name"
                  className="form-label mb-1 fs-5 ftlink text-left"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  Name or nickname
                </label>
                <input
                  type="text"
                  className="form-control w-100 ftzevtt fs-5 rounded-0 placeholder-login"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "45px",
                    fontWeight: "600",
                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>

              {/* <div className="mb-2">
                     <label
                       htmlFor="dateOfBirth"
                       className="form-label mb-1 fs-5 ftlink text-left"
                       style={{
                         color: "#000000",
                         lineHeight: "27.24px",
                         fontWeight: "600",
                       }}
                     >
                       Date of birth
                     </label>
                     <input
                       type="date"
                       className="form-control w-100 ftzevtt fs-5 rounded-0 placeholder-login"
                       id="dateofbirth"
                       value={dateOfBirth}
                       onChange={(e) => setDateOfBirth(e.target.value)}
                       required
                       style={{
                         border: "1px solid #6D6D6D",
                         maxWidth: "539px",
                         height: "45px",
                         fontWeight: "600",
                         lineHeight: "27.24px",
                         color: "#7B7B7B",
                       }}
                     />
                   </div>
     
                   <div className="mb-2">
                     <label
                       htmlFor="gender"
                       className="form-label mb-1 fs-5 ftlink text-left"
                       style={{
                         color: "#000000",
                         lineHeight: "27.24px",
                         fontWeight: "600",
                       }}
                     >
                       Gender
                     </label>
                     <Form.Select
                       aria-label="Select Country"
                       className="form-control fw600 w-100 ftzevtt fs-5 rounded-0 placeholder-login"
                       id="gender"
                       style={{
                         border: "1px solid #6D6D6D",
                         maxWidth: "539px",
                         height: "45px",
     
                         lineHeight: "27.24px",
                       }}
                       value={gender}
                       onChange={(e) => setGender(e.target.value)}
                       // onChange={handleCountrySelect} // Handle the change event
                     >
                       <option value=""> </option>
                       {genders.map((gender, index) => (
                         <option key={index} value={gender}>
                           {gender}
                         </option>
                       ))}
                     </Form.Select>
                   </div>
     
                   <div className="mb-2">
                     <label
                       htmlFor="city"
                       className="form-label mb-1 fs-5 ftlink text-left"
                       style={{
                         color: "#000000",
                         lineHeight: "27.24px",
                         fontWeight: "600",
                       }}
                     >
                       City
                     </label>
                     <input
                       type="text"
                       className="form-control w-100 ftzevtt fs-5 rounded-0 placeholder-login"
                       id="city"
                       // value={city}
                       // onChange={(e) => setCity(e.target.value)}
                       value={searchQuery} // Bind input value to searchQuery
                       onChange={handleInputChange} // Trigger input change handler
                       required
                       style={{
                         border: "1px solid #6D6D6D",
                         maxWidth: "539px",
                         height: "45px",
                         fontWeight: "600",
                         lineHeight: "27.24px",
                         color: "#7B7B7B",
                       }}
                     />
     
                     {suggestions.length > 0 && (
                       <ul className="suggestions-dropdown">
                         {suggestions.map((cityObj, index) => (
                           <li
                             key={index}
                             onClick={() => handleSuggestionClick(cityObj)}
                           >
                             {cityObj.city}, {cityObj.country}
                           </li>
                         ))}
                       </ul>
                     )}
                   </div> */}

              <div className="mb-2">
                <label
                  htmlFor="password"
                  className="form-label mb-1 fs-5 ftlink"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  Password
                </label>

                <input
                  type="password"
                  className="form-control w-100 rounded-0 px-4 ftzevtt fs-5 placeholder-login"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="At least 8 characters"
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "45px",
                    fontWeight: "600",
                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>

              <div className=" mx-auto " style={{ marginBottom: "10px" }}>
                <div
                  className="mt-2 fs-5 d-flex justify-content-center"
                  style={{ color: "black", textAlign: "center" }}
                >
                  Are you a bookseller?
                </div>
                <div className="d-flex mt-3 justify-content-center align-items-center gap-3 ">
                  <div
                    className="border border-dark p-1 w-100"
                    style={{ maxWidth: "90px" }}
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2 fs-4 text-dark  ">
                      Yes
                      <input
                        type="radio"
                        value="Yes"
                        checked={isBookseller === "Yes"}
                        onChange={() => setIsBookseller("Yes")}
                        className="mt-1"
                        style={{ width: "20px", height: "20px" }}
                      />{" "}
                    </div>
                  </div>
                  <div
                    className="border border-dark p-1 w-100"
                    style={{ maxWidth: "90px" }}
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2 fs-4 text-dark  ">
                      No
                      <input
                        type="radio"
                        value="No"
                        checked={isBookseller === "No"}
                        onChange={() => setIsBookseller("No")}
                        className="mt-1"
                        style={{ width: "20px", height: "20px" }}
                      />{" "}
                    </div>
                  </div>
                </div>
              </div>

              {isBookseller === "Yes" && (
                <>
                  <div className="mt-2">
                    <input
                      type="text"
                      placeholder="Store's name"
                      className="form-control w-100 ftzevtt fs-5 rounded-0 placeholder-login"
                      id="name"
                      value={storeName}
                      onChange={(e) => setStoreName(e.target.value)}
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        maxWidth: "539px",
                        height: "45px",
                        fontWeight: "600",
                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>

                  <div className="my-2">
                    <input
                      type="text"
                      placeholder="Address"
                      className="form-control w-100 ftzevtt fs-5 rounded-0 placeholder-login"
                      id="name"
                      value={storeAddress}
                      onChange={(e) => setStoreAddress(e.target.value)}
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        maxWidth: "539px",
                        height: "45px",
                        fontWeight: "600",
                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>
                </>
              )}
              <div className="text-center mt-3 mb-2">
                <Button
                  className="fs-5 text-white loginbtnwidmodel border-0 fw-bold w-100 "
                  type="submit"
                  style={{
                    backgroundColor: "#34C3C9",
                    lineHeight: "27.24px",
                    color: "#000000",
                    maxWidth: "231px",
                    height: "44px",
                  }}
                  onClick={handleSubmit}
                >
                  Sign up
                </Button>
              </div>

              <div className="form-check">
                <input
                  className="form-check-input rounded-0 placeholder-login"
                  type="checkbox"
                  required
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  // defaultValue
                  id="flexCheckDefaultsigup"
                  style={{ border: "1px solid #6D6D6D ", marginTop: "-0px" }}
                />
                <label
                  className="form-check-label  text-center"
                  htmlFor="flexCheckDefaultsigup"
                  style={{
                    color: "#4C4C4C",
                    fontWeight: "600",
                    fontSize: "15.5px",
                    lineHeight: "21.79px",
                    marginTop: "-2px",
                    marginLeft: "-3px",
                  }}
                >
                  By signing up, you agree to{" "}
                  <span
                    style={{ color: "#EF0707", cursor: "pointer" }}
                    onClick={() => navigate("/terms")}
                  >
                    Terms of use
                  </span>
                  ,
                  <span
                    style={{ color: "#E33629", cursor: "pointer" }}
                    onClick={() => navigate("/privacy")}
                  >
                    {" "}
                    Privacy Policy{" "}
                  </span>
                  and{" "}
                  <span
                    style={{ color: "#E33629", cursor: "pointer" }}
                    onClick={() => navigate("/cookies")}
                  >
                    {" "}
                    Cookie Policy
                  </span>
                </label>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 py-0">
          <div className="text-center  mt-md-2 w-100">
            <div
              className="text-center fw600 fs-6  "
              style={{
                color: "#4C4C4C",

                lineHeight: "10.79px",
              }}
            >
              Already have an account,{" "}
              <span
                className="cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={handleLoginShow}
              >
                Sign up
              </span>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* SEnd EMAIL FOR FORGET PASSWORD */}

      <Modal
        show={fPShow}
        onHide={handleFPClose}
        centered
        className="custom-modal custom-modalhegit modalforget "
      >
        <Modal.Header className="border-0">
          <img
            className="border-0 closebtn  closebtnchpas"
            src={require("../components/image/close.png")}
            alt="close"
            onClick={handleFPClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          Forgot password?
        </Modal.Title>
        <Modal.Body className="modelbody text-center">
          <form className="textleft margg mt-3" onSubmit={handleForgotPassword}>
            <div
              className=" mt-4 mb-5"
              style={{
                color: "black",
                fontWeight: "600",
                fontSize: "20px",
                lineHeight: "21.79px",
                marginTop: "-2px",
                marginLeft: "-3px",
              }}
            >
              Enter the email associated with your account. We'll send you a
              secure link to reset your password.
            </div>
            <div className="mb-3">
              <label
                htmlFor="cnpassword"
                className="form-label fw600 fs-5 ftzevtt text-left"
              >
                Eamil
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type="email"
                  className="form-control w-100 fs-5 ftzevtt outline-none  rounded-4 placeholder-login"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ border: "0.1px " }}
                />

                {/* <i
                          className={`bi ${
                            passwordVisible ? "bi-eye" : "bi-eye-slash"
                          }`}
                        ></i> */}
              </div>
            </div>
          </form>
          <div className="mt-5 text-center">
            <button
              type="submit"
              className="w-100  eventcrtwid fw600 fs-5 !text-white text-center rounded-1 border-0"
              style={{
                maxWidth: "195px",
                height: "44px",
                backgroundColor: "#34C3C9",
              }}
              onClick={handleForgotPassword}
            >
              Reset password
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {fShow && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
          <div className="m-auto relative w-full max-w-[560px] rounded-2xl bg-white p-6 shadow-2xl ring-1 ring-black/5 sm:p-8">
            <button
              aria-label="Close"
              onClick={handleFClose}
              className="absolute right-4 top-4 rounded-full p-2 text-slate-500 hover:bg-slate-50"
            >
              <X size={18} />
            </button>

            {/* Header Title */}
            <h1 className="mb-6 text-center text-2xl font-bold tracking-tight text-slate-900">
              Reset your password
            </h1>
            <p className="mb-6 text-center text-sm text-slate-500">
              Please create a password with at least 10 characters, avoid common
              words, and do not reuse passwords.
            </p>
            <form className="space-y-5">
              <div className="relative">
                <label className="text-sm font-medium w-full">
                  New Password
                  <div className="relative mt-1 w-full">
                    <input
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                      type={passwordNewVisible ? "text" : "password"}
                      className="w-full rounded-xl border border-[#e5e5e5] bg-white px-3 py-2 pr-9 text-sm outline-none focus:ring-2 focus:ring-[var(--primary)]"
                      placeholder="••••••••"
                    />
                    <button
                      type="button"
                      onClick={togglePasswordNewVisibility}
                      className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-slate-500 hover:bg-slate-50"
                    >
                      {passwordNewVisible ? (
                        <EyeOff size={16} />
                      ) : (
                        <Eye size={16} />
                      )}
                    </button>
                  </div>
                </label>
                <label className="text-sm font-medium w-full">
                  Confirm New Password
                  <div className="relative mt-1 w-full">
                    <input
                      value={confirmNewPassword}
                      onChange={(e) => setConfirmNewPassword(e.target.value)}
                      required
                      type={passwordNewVisible ? "text" : "password"}
                      className="w-full rounded-xl border border-[#e5e5e5] bg-white px-3 py-2 pr-9 text-sm outline-none focus:ring-2 focus:ring-[var(--primary)]"
                      placeholder="••••••••"
                    />
                    <button
                      type="button"
                      onClick={togglePasswordNewVisibility}
                      className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-slate-500 hover:bg-slate-50"
                    >
                      {passwordNewVisible ? (
                        <EyeOff size={16} />
                      ) : (
                        <Eye size={16} />
                      )}
                    </button>
                  </div>
                </label>
              </div>

              {/* Submit button */}
              <button
                type="submit"
                onClick={handleSubmitForget}
                className="mt-2 w-full rounded-xl bg-[#34C3C9] py-2.5 text-sm font-semibold text-white shadow-md transition hover:brightness-95"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
      {/* Modal ForGetPassword Component */}
      <Modal
        show={false}
        onHide={handleFClose}
        centered
        className="custom-modal custom-modalhegit "
      >
        <Modal.Header className="border-0">
          <img
            className="border-0 closebtn  closebtnchpas"
            src={require("../components/image/close.png")}
            alt="close"
            onClick={handleFClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          Change your password
        </Modal.Title>
        <Modal.Body className="modelbody text-center">
          <form className="textleft margg mt-3" onSubmit={handleSubmitForget}>
            <div className="mb-3">
              <label
                htmlFor="npassword"
                className="form-label fw600 fs-5 ftzevtt text-left"
              >
                New Password
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordNewVisible ? "text" : "password"}
                  className="form-control w-100 fs-5 ftzevtt outline-none  rounded-4 placeholder-login"
                  id="npassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  style={{ border: "0.1px " }}
                  required
                />
                <div onClick={togglePasswordNewVisibility}>
                  {passwordNewVisible ? (
                    <FaEyeSlash className="m-3" size={24} />
                  ) : (
                    <FaEye className="m-3" size={24} />
                  )}
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="cnpassword"
                className="form-label fw600 fs-5 ftzevtt text-left"
              >
                Confirm New Password
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordNewVisible1 ? "text" : "password"}
                  className="form-control w-100 fs-5 ftzevtt outline-none  rounded-4 placeholder-login"
                  id="cnpassword"
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  style={{ border: "0.1px " }}
                  required
                />
                <div onClick={togglePasswordNewVisibility1}>
                  {passwordNewVisible1 ? (
                    <FaEyeSlash className="m-3" size={24} />
                  ) : (
                    <FaEye className="m-3" size={24} />
                  )}
                </div>
                {/* <img
                  className="m-3"
                  src={require("../pages/image/eyepassw.png")}
                  width="24"
                  height="24"
                  onClick={togglePasswordNewVisibility}
                /> */}
                {/* <i
                        className={`bi ${
                          passwordVisible ? "bi-eye" : "bi-eye-slash"
                        }`}
                      ></i> */}
              </div>
            </div>
          </form>
          <div className="mt-4 text-center">
            <button
              className="w-100  eventcrtwid fw600 fs-5 !text-white text-center rounded-1 border-0"
              style={{
                maxWidth: "167px",
                height: "44px",
                backgroundColor: "#34C3C9",
              }}
              onClick={handleSubmitForget}
            >
              Submit
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* OLD CODE - Future use: Ambassador restriction modal */}
      {/* <Modal
        show={wShow}
        onHide={handleCloseW}
        centered
        className="custom-gropmodelwel roundedambdmodl"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseW}
          />
        </Modal.Header>
        <Modal.Title className="mx-5 "></Modal.Title>
        <Modal.Body className="mx-4 mt-sm-2">
          <div
            className=" text-center mt-lg-2 w-100 ftzinput "
            style={{ fontSize: "24px" }}
          >
            {lg?.bookClubsAndSilentReadings || "Book Clubs and Silent Readings are led by Ambassadors."}
          </div>
          <div
            className=" text-center w-100 mt-lg-4 mt-2 ftzinput "
            style={{ fontSize: "24px" }}
          >
            <span
              className="text-decoration-underline"
              style={{ color: "#34c3c9", cursor: "pointer" }}
              onClick={handleAmbasButtonClickModel}
            >
              {lg?.becomeAnAmbassador || "Become an Ambassador"}{" "}
            </span>
            {lg?.toLeadOneOrExplore || "to lead one or explore and join"}{" "}
            <span
              className="text-decoration-underline"
              style={{ color: "#34c3c9", cursor: "pointer" }}
              onClick={handleLocationClick}
            >
              {lg?.eventsAvailable || "events available."}
            </span>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default HomePage2;
